<template>
    <transition name="modal">
        <div class="modal__mask modalpassword bg-black bg-opacity-50" v-if="abrirModal">
            <div class="modal__wrapper">
                <div class="modal__container reset bg-white dark:bg-slate-800">
                    <div class="content__modal">
                        <div class="inner__modal">
                            <div class="flex items-center gap-3 mb-6">
                                <i class="fa fa-lock text-2xl text-gray-700 dark:text-gray-300"></i>
                                <h2 class="text-lg font-semibold">Alterar senha</h2>
                            </div>

                            <form class="space-y-4">
                                <div class="form-field">
                                    <label class="form-field-label form-field-label-required" for="senhaAtual">Senha atual</label>
                                    <input class="field" type="password" v-model="cadastro.senhaAtual" id="senhaAtual">
                                </div>

                                <div class="form-field">
                                    <label class="form-field-label form-field-label-required" for="senhaNova">Senha nova</label>
                                    <div class="relative">
                                        <input class="field" :type="senhaVisivel ? 'text' : 'password'" v-model="cadastro.novaSenha" id="senhaNova">
                                        <button 
                                            type="button"
                                            class="toggle-password-btn" 
                                            :class="{ 'senha-visivel': senhaVisivel }"
                                            @click="toggleSenhaVisibilidade"
                                            tabindex="-1">
                                        </button>
                                    </div>
                                </div>

                                <div class="form-field">
                                    <label class="form-field-label form-field-label-required" for="confirmacaoNovaSenha">Confirmação nova senha</label>
                                    <div class="relative">
                                        <input class="field" :type="senhaVisivel ? 'text' : 'password'" v-model="cadastro.confirmacaoNovaSenha" id="confirmacaoNovaSenha">
                                        <button 
                                            type="button"
                                            class="toggle-password-btn" 
                                            :class="{ 'senha-visivel': senhaVisivel }"
                                            @click="toggleSenhaVisibilidade"
                                            tabindex="-1">
                                        </button>
                                    </div>
                                </div>

                                <div class="flex gap-3 mt-6">
                                    <button type="button" class="btn-secondary" @click="closeModal">Cancelar</button>
                                    <button type="button" class="px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors shadow-sm" @click="confirmar">Alterar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';
import SHA256 from 'crypto-js/sha256';

export default {
    computed: {
        ...mapGetters({
            user: 'auth/user',
            abrirModalValue: 'GET_ABRIR_ALTERAR_SENHA'
        }),
        abrirModal() {
            return this.abrirModalValue > 0;
        }
    },
    data() {
        return { 
            senhaVisivel: false,
            cadastro: {
                senhaAtual: '',
                novaSenha: '',
                confirmacaoNovaSenha: '',
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_ABRIR_ALTERAR_SENHA", 0);
            this.cadastro = {
                senhaAtual: '',
                novaSenha: '',
                confirmacaoNovaSenha: '',
            };
            this.erroConfirmar = false;
        },
        toggleSenhaVisibilidade() {
            this.senhaVisivel = !this.senhaVisivel;
        },
        validarForm(){
            if(!this.cadastro.senhaAtual){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Senha atual não foi informada`,
                });
                return false;
            }

            if(!this.cadastro.novaSenha){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Nova senha não foi informada`,
                });
                return false;
            }

            if(!this.cadastro.confirmacaoNovaSenha){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Confirmação da nova senha não foi informada`,
                });
                return false;
            }

            if(this.cadastro.novaSenha != this.cadastro.confirmacaoNovaSenha){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Nova senha é diferente da confirmação de nova senha`,
                });
                return false;
            }

            return true;
        },
        async confirmar(){
            if(!this.validarForm()){
                this.erroConfirmar = true;
            }else{
                 
                var obj = { 
                    SenhaAtual: this.cadastro.senhaAtual ? SHA256(this.cadastro.senhaAtual).toString() : '', 
                    NovaSenha: this.cadastro.novaSenha ? SHA256(this.cadastro.novaSenha).toString() : '', 
                    ConfirmarNovaSenha: this.cadastro.confirmacaoNovaSenha ? SHA256(this.cadastro.confirmacaoNovaSenha).toString() : '' 
                };

                await api.post('/cliente/alterar-senha', obj).then((retorno) => {
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: 'Alterar senha',
                                text: 'Alteração realizada com sucesso',
                                });
                                this.$store.commit("SET_ABRIR_ALTERAR_SENHA", 0);
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Alteração de senha',
                            text: `${error.response.data.data[0]}`,
                        });
                        
                    });


            }
        }
    },
};
</script>

<style lang="scss">
.modalpassword .modal__wrapper .modal__container.reset {
    width: 450px !important;
    max-height: 90vh !important;
    overflow-y: auto;
}
</style>
